import { getImage, GatsbyImage } from "gatsby-plugin-image";
import * as React from 'react';
export default {
  getImage,
  GatsbyImage,
  React
};